// import { useEffect } from "react";
// import { Link } from "react-router-dom";
// import { BatteryIcon, GearIcon, AtomIcon, CycleIcon, TruckIcon, ShieldIcon } from "../Icons";

// function WhatWeDoPage() {
//   useEffect(() => {
//     window.scrollTo(0, 0);
//     const reveals = document.querySelectorAll(".reveal");
//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach((e) => {
//         if (e.isIntersecting) { e.target.classList.add("visible"); observer.unobserve(e.target); }
//       });
//     }, { threshold: 0.1 });
//     reveals.forEach((r) => observer.observe(r));
//     return () => observer.disconnect();
//   }, []);

//   return (
//     <main style={{ paddingTop: "80px" }}>

//       {/* PAGE HERO */}
//       <section className="page-hero">
//         <div className="hero-grid-bg"></div>
//         <div className="hero-glow" style={{ opacity: 0.4 }}></div>
//         <div className="section-inner" style={{ position: "relative", zIndex: 2 }}>
//           <div className="section-tag">What We Do</div>
//           <h1 className="section-title display" style={{ fontSize: "clamp(3rem, 6vw, 5.5rem)", marginBottom: "1.2rem" }}>
//             Turning Dead Batteries<br />Into Living Resources
//           </h1>
//           <p className="section-body" style={{ maxWidth: "620px" }}>
//             Every lithium-ion battery that reaches its end of life is a resource waiting to be recovered. We built the infrastructure to make that happen — at scale, safely, and in compliance with India's growing regulatory framework.
//           </p>
//         </div>
//       </section>

//       {/* FOUR PILLARS */}
//       <section>
//         <div className="section-inner">
//           <div className="section-tag">Our Four-Stage Model</div>
//           <h2 className="section-title display">How We Close the Loop</h2>

//           <div className="page-pillar-grid reveal">

//             <div className="page-pillar-card">
//               <div className="page-pillar-num">01</div>
//               <div className="page-pillar-icon"><BatteryIcon size={40} /></div>
//               <h3>Collection</h3>
//               <p>
//                 We partner directly with EV manufacturers, battery pack assemblers, scrap dealers, and logistics aggregators to collect end-of-life lithium-ion batteries from across India. Our collection network is built to scale alongside the country's EV adoption curve — starting in Rajasthan and expanding nationally.
//               </p>
//               <ul className="page-pillar-list">
//                 <li>Doorstep pickup for OEMs and large producers</li>
//                 <li>Aggregator partnerships for distributed collection</li>
//                 <li>Chemistries: LFP, NMC, NCA, LCO, LTO</li>
//               </ul>
//             </div>

//             <div className="page-pillar-card">
//               <div className="page-pillar-num">02</div>
//               <div className="page-pillar-icon"><GearIcon size={40} /></div>
//               <h3>Safe Processing</h3>
//               <p>
//                 Batteries arriving at our facility go through a rigorous intake and safety assessment before processing begins. Every pack is fully discharged to zero volts, dismantled into modules, and then cells are shredded under controlled conditions — eliminating thermal runaway risk and ensuring worker safety.
//               </p>
//               <ul className="page-pillar-list">
//                 <li>Zero-volt discharge before any dismantling</li>
//                 <li>Fire-safe shredding environment</li>
//                 <li>Full chain-of-custody documentation</li>
//               </ul>
//             </div>

//             <div className="page-pillar-card">
//               <div className="page-pillar-num">03</div>
//               <div className="page-pillar-icon"><AtomIcon size={40} /></div>
//               <h3>Material Extraction</h3>
//               <p>
//                 Post-shredding, our separation process isolates Black Mass — the high-value powder that contains lithium, cobalt, nickel, and manganese — from aluminium foil, copper foil, steel casings, and plastics. Each material stream is packaged and sold to the appropriate downstream buyer.
//               </p>
//               <ul className="page-pillar-list">
//                 <li>Black Mass: Li, Co, Ni, Mn</li>
//                 <li>Metals: Cu, Al, Fe</li>
//                 <li>Plastics separated and recovered</li>
//               </ul>
//             </div>

//             <div className="page-pillar-card">
//               <div className="page-pillar-num">04</div>
//               <div className="page-pillar-icon"><CycleIcon size={40} /></div>
//               <h3>Supply Chain Re-entry</h3>
//               <p>
//                 Recovered Black Mass and separated metals are supplied to refiners, battery manufacturers, and material processors. This closes the loop — critical minerals that would otherwise be landfilled re-enter the battery supply chain, reducing India's dependence on imported virgin materials.
//               </p>
//               <ul className="page-pillar-list">
//                 <li>Black Mass supplied to hydromet refiners</li>
//                 <li>Metals sold to domestic smelters</li>
//                 <li>EPR certificates issued to source OEMs</li>
//               </ul>
//             </div>

//           </div>
//         </div>
//       </section>

//       {/* WHAT WE HANDLE */}
//       <section style={{ background: "var(--panel)" }}>
//         <div className="section-inner">
//           <div className="section-tag">Battery Chemistries</div>
//           <h2 className="section-title display">What We Handle</h2>
//           <p className="section-body">
//             Our facility is equipped to safely process the full range of lithium-ion battery chemistries in use across India's EV, storage, and consumer electronics markets.
//           </p>

//           <div className="chemistry-grid reveal">
//             {[
//               { code: "LFP", name: "Lithium Iron Phosphate", use: "E-rickshaws, 2W, stationary storage" },
//               { code: "NMC", name: "Nickel Manganese Cobalt", use: "Passenger EVs, BESS" },
//               { code: "NCA", name: "Nickel Cobalt Aluminium", use: "High-performance EVs" },
//               { code: "LCO", name: "Lithium Cobalt Oxide", use: "Consumer electronics, laptops" },
//               { code: "LTO", name: "Lithium Titanate", use: "Fast-charge buses, industrial" },
//               { code: "LMFP", name: "Lithium Manganese Iron Phosphate", use: "Next-gen 2W &amp; 4W EVs" },
//             ].map((c) => (
//               <div className="chemistry-card" key={c.code}>
//                 <div className="chemistry-code">{c.code}</div>
//                 <div className="chemistry-name">{c.name}</div>
//                 <div className="chemistry-use" dangerouslySetInnerHTML={{ __html: c.use }} />
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* COMPLIANCE */}
//       <section>
//         <div className="section-inner">
//           <div className="section-tag">Compliance</div>
//           <h2 className="section-title display">Built to the Standard</h2>
//           <div className="compliance-row reveal">
//             <div className="compliance-item">
//               <div className="usp-icon-wrap" style={{ marginBottom: "1rem" }}><ShieldIcon size={22} /></div>
//               <h3>EPR Registered</h3>
//               <p>Fully registered under India's Battery Waste Management Rules 2022. We issue EPR compliance certificates to producers.</p>
//             </div>
//             <div className="compliance-item">
//               <div className="usp-icon-wrap" style={{ marginBottom: "1rem" }}><TruckIcon size={22} /></div>
//               <h3>Hazardous Waste Authorised</h3>
//               <p>Authorised under the Hazardous Waste Management Rules for handling, storage, and processing of battery waste.</p>
//             </div>
//             <div className="compliance-item">
//               <div className="usp-icon-wrap" style={{ marginBottom: "1rem" }}><AtomIcon size={22} /></div>
//               <h3>ESG Aligned</h3>
//               <p>Our operations align with global ESG reporting frameworks — helping producers meet their Scope 3 obligations.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section style={{ background: "var(--panel)", borderTop: "var(--accent-line)" }}>
//         <div className="section-inner" style={{ textAlign: "center" }}>
//           <h2 className="section-title display">Ready to Recycle?</h2>
//           <p className="section-body" style={{ margin: "0 auto 2rem" }}>
//             Whether you have battery waste to dispose of or want to partner for EPR compliance, we're ready to talk.
//           </p>
//           <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap" }}>
//             <a href="/#contact" className="btn-primary">Get in Touch</a>
//             <Link to="/" className="btn-outline">← Back to Home</Link>
//           </div>
//         </div>
//       </section>

//     </main>
//   );
// }

// export default WhatWeDoPage;

import { useEffect } from "react";
import { Link } from "react-router-dom";
import { BatteryIcon, GearIcon, AtomIcon, CycleIcon, TruckIcon, ShieldIcon } from "../Icons";

function WhatWeDoPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    const reveals = document.querySelectorAll(".reveal");
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add("visible"); observer.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    reveals.forEach((r) => observer.observe(r));
    return () => observer.disconnect();
  }, []);

  return (
    <main style={{ paddingTop: "80px" }}>

      {/* PAGE HERO */}
      <section className="page-hero">
        <div className="hero-grid-bg"></div>
        <div className="hero-glow" style={{ opacity: 0.4 }}></div>
        <div className="section-inner" style={{ position: "relative", zIndex: 2 }}>
          <div className="section-tag">What We Do</div>
          <h1 className="section-title display" style={{ fontSize: "clamp(3rem, 6vw, 5.5rem)", marginBottom: "1.2rem" }}>
            Turning Dead Batteries<br />Into Living Resources
          </h1>
          <p className="section-body" style={{ maxWidth: "680px" }}>
            Every lithium-ion battery that reaches end of life is a resource waiting to be recovered. We built the infrastructure to make that happen — at scale, safely, and in compliance with India's Battery Waste Management Rules 2022. Our 5 MTD facility in Jaipur uses advanced mechanical and thermal processes to extract black mass, copper, and aluminium. Future phases will integrate hydrometallurgical recovery of lithium, nickel, and cobalt.
          </p>
        </div>
      </section>

      {/* FOUR PILLARS */}
      <section>
        <div className="section-inner">
          <div className="section-tag">Our Four-Stage Model</div>
          <h2 className="section-title display">How We Close the Loop</h2>

          <div className="page-pillar-grid reveal">

            <div className="page-pillar-card">
              <div className="page-pillar-num">01</div>
              <div className="page-pillar-icon"><BatteryIcon size={40} /></div>
              <h3>Collection</h3>
              <p>
                We partner directly with EV manufacturers, battery pack assemblers, EV service centres, scrap dealers, solar/inverter installers, and logistics aggregators to collect end-of-life lithium-ion batteries from across India. Our collection network starts in Rajasthan and expands nationally across Delhi NCR, Gujarat, and beyond — building alongside the country's EV adoption curve. Every incoming consignment is documented for chain-of-custody and EPR compliance from the moment of pickup.
              </p>
              <ul className="page-pillar-list">
                <li>Doorstep pickup for OEMs and large batch producers</li>
                <li>Aggregator partnerships for distributed informal-sector collection</li>
                <li>Chemistries accepted: LFP, NMC, NCA, LCO, LTO, LMFP</li>
                <li>Form factors: cylindrical, prismatic, pouch cells</li>
                <li>Sources: EVs, consumer electronics, ESS, manufacturing scrap</li>
                {/* <li>Raw material rates: Mobile scrap ₹150/kg · Laptop scrap ₹230/kg</li> */}
              </ul>
            </div>

            <div className="page-pillar-card">
              <div className="page-pillar-num">02</div>
              <div className="page-pillar-icon"><GearIcon size={40} /></div>
              <h3>Safe Processing</h3>
              <p>
                Batteries arriving at our Jaipur facility go through rigorous intake and safety assessment before processing begins. Every pack is fully discharged to zero volts (safe crushing voltage ≈2.5V per cell) — this is the step most informal recyclers skip, and it's the primary cause of battery fires. Discharged packs are then manually dismantled into modules and cells, with BMS, electronics, and casings separated. Cells are then shredded in a sealed inert-atmosphere chamber — eliminating thermal runaway risk and ensuring worker safety throughout.
              </p>
              <ul className="page-pillar-list">
                <li>Zero-volt discharge before any dismantling — no exceptions</li>
                <li>Inert atmosphere shredding with electrolyte vapour capture</li>
                <li>Gas monitoring: H₂, CO₂, CO, CH₄ sensors active at all times</li>
                <li>Full chain-of-custody documentation at every processing stage</li>
                <li>Facility area: ~30,100 sq. ft. industrial setup in Jaipur</li>
                <li>Power requirement: 462 kW · Operating days: 300/year</li>
              </ul>
            </div>

            <div className="page-pillar-card">
              <div className="page-pillar-num">03</div>
              <div className="page-pillar-icon"><AtomIcon size={40} /></div>
              <h3>Material Extraction</h3>
              <p>
                Post-shredding, our multi-stage separation process isolates Black Mass — the high-value powder containing lithium, cobalt, nickel, and manganese — from aluminium foil, copper foil, steel casings, and plastics. Black Mass purity exceeds 85% by weight, achievable down to &lt;2 micron separation. Each material stream carries a market rate and is packaged and sold to the appropriate downstream buyer.
              </p>
              <ul className="page-pillar-list">
                <li>Black Mass: Li, Co, Ni, Mn at &gt;85% purity</li>
                <li>Copper foil: ~5% of input weight </li>
                <li>Aluminium foil: ~12% of input weight</li>
                <li>Iron/steel: ~10% of input weight </li>
                <li>Plastics: ~12% of input weight, sorted and recycled</li>
                <li>Material test certificates issued per output batch</li>
              </ul>
            </div>

            <div className="page-pillar-card">
              <div className="page-pillar-num">04</div>
              <div className="page-pillar-icon"><CycleIcon size={40} /></div>
              <h3>Supply Chain Re-entry</h3>
              <p>
                Recovered Black Mass and separated metals are supplied to registered refiners, battery manufacturers, and material processors. Confirmed Black Mass buyers include Attero Recycling, SungEel India Recycling, LOHUM Cleantech, and Exigo Recycling — all active hydrometallurgical operators who extract Li, Co, Ni, and Mn for new battery manufacturing. This closes the loop: critical minerals that would otherwise be landfilled re-enter India's domestic battery supply chain, reducing dependence on imported virgin materials from DRC, Chile, and China.
              </p>
              <ul className="page-pillar-list">
                <li>Black Mass supplied to: Attero, SungEel India, LOHUM, Exigo Recycling</li>
                <li>Metals sold to domestic smelters at current commodity rates</li>
                <li>EPR certificates issued to source OEMs — CPCB-ready documentation</li>
                <li>Full material traceability from input batch to end buyer</li>
              </ul>
            </div>

          </div>
        </div>
      </section>

      {/* FACILITY SPECS */}
      {/* <section style={{ background: "var(--panel)" }}>
        <div className="section-inner">
          <div className="section-tag">Facility Specifications — Jaipur</div>
          <h2 className="section-title display">What's Inside the Plant</h2>
          <p className="section-body">
            Our Jaipur facility is designed and documented by Corpseed ITES Pvt. Ltd. in a full Detailed Project Report. Key infrastructure and equipment specifications are listed below.
          </p>
          <div className="compare-table reveal" style={{ marginTop: "3rem" }}>
            <div className="compare-header">
              <div>Component</div>
              <div className="compare-col-header">Specification</div>
              <div className="compare-col-header alankaar">CAPEX Allocation</div>
            </div>
            {[
              ["Plant Construction (30,100 sq. ft.)", "Industrial build @ ₹1,500/sq.ft.", "₹4.51 Crore"],
              ["Plant Machinery (Shredders, Mills, Separators)", "Industrial shredders, ball mills, magnetic & eddy separators, sieves", "₹2.30 Crore"],
              ["Electrical Setup", "Transformer, panels, wiring — 462 kW load", "₹35 Lakh"],
              ["ZLD ETP + Hazardous Handling", "Zero Liquid Discharge effluent treatment plant", "₹25 Lakh"],
              ["Fire Safety System", "Hydrant network, NOC-compliant suppression system", "₹20 Lakh"],
              ["Material Handling", "Forklift, conveyor belts, sorting bins", "₹15 Lakh"],
              ["Licences & Approvals", "SPCB, CPCB, EPR registration, Hazardous Waste authorisation", "₹8 Lakh"],
              ["Total CAPEX", "Full facility to Black Mass stage", "₹8.34 Crore"],
            ].map(([label, spec, cost]) => (
              <div className="compare-row" key={label}>
                <div className="compare-label">{label}</div>
                <div className="compare-val">{spec}</div>
                <div className="compare-val pos">{cost}</div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* WHAT WE HANDLE */}
      <section>
        <div className="section-inner">
          <div className="section-tag">Battery Chemistries</div>
          <h2 className="section-title display">What We Handle</h2>
          <p className="section-body">
            Our facility is equipped to safely process the full range of lithium-ion battery chemistries in use across India's EV, storage, and consumer electronics markets. Each chemistry has a distinct composition and recovery profile.
          </p>

          <div className="chemistry-grid reveal">
            {[
              { code: "LFP", name: "Lithium Iron Phosphate", use: "E-rickshaws, 2W, stationary storage", note: "Phosphorous content requires adapted pyrometallurgical approach" },
              { code: "NMC", name: "Nickel Manganese Cobalt", use: "Passenger EVs, BESS", note: "Li 2.02%, Mn 17.3%, Ni 8.74%, Co 3.3% " },
              { code: "NCA", name: "Nickel Cobalt Aluminium", use: "High-performance EVs", note: "High nickel content — premium recovery value" },
              { code: "LCO", name: "Lithium Cobalt Oxide", use: "Consumer electronics, laptops", note: "Li 3.12%, Co 6.02%, Ni 4.12% " },
              { code: "LTO", name: "Lithium Titanate", use: "Fast-charge buses, industrial", note: "High cycle life — stable chemistry for collection" },
              { code: "LMFP", name: "Lithium Manganese Iron Phosphate", use: "Next-gen 2W &amp; 4W EVs", note: "Emerging chemistry — Li 8.1%, Mn 30.6%, Co 1.2%" },
            ].map((c) => (
              <div className="chemistry-card" key={c.code}>
                <div className="chemistry-code">{c.code}</div>
                <div className="chemistry-name">{c.name}</div>
                <div className="chemistry-use" dangerouslySetInnerHTML={{ __html: c.use }} />
                <div className="chemistry-use" style={{ marginTop: "0.5rem", opacity: 0.7, fontSize: "0.82em" }}>{c.note}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* OUTPUT PRODUCTS */}
      <section style={{ background: "var(--panel)" }}>
        <div className="section-inner">
          <div className="section-tag">What Comes Out</div>
          <h2 className="section-title display">Three Co-Product Streams</h2>
          <p className="section-body">
            The recycling process generates three primary output categories — each with defined market buyers, pricing, and downstream use.
          </p>
          <div className="compliance-row reveal" style={{ marginTop: "3rem" }}>
            <div className="compliance-item">
              <div className="usp-icon-wrap" style={{ marginBottom: "1rem" }}><AtomIcon size={22} /></div>
              <h3>Black Mass</h3>
              <p>Primary co-product — fine black powder containing Li, Co, Ni, Mn extracted from cathode and anode materials. Purity &gt;85% by weight. Less than 1% impurities achievable. </p>
            </div>
            <div className="compliance-item">
              <div className="usp-icon-wrap" style={{ marginBottom: "1rem" }}><CycleIcon size={22} /></div>
              <h3>Critical Minerals (Future Phase)</h3>
              <p>Via hydrometallurgical partners: battery-grade lithium carbonate (Li₂CO₃), cobalt sulphate (CoSO₄), nickel sulphate (NiSO₄), and manganese sulphate (MnSO₄) — directly usable in new LIB cell manufacturing. Closes the full circular loop.</p>
            </div>
            <div className="compliance-item">
              <div className="usp-icon-wrap" style={{ marginBottom: "1rem" }}><GearIcon size={22} /></div>
              <h3>Secondary Materials</h3>
              <p>High-grade copper foil , aluminium foil , steel casings , and sorted plastics . All sold to domestic smelters and recyclers.</p>
            </div>
          </div>
        </div>
      </section>

      {/* COMPLIANCE */}
      <section>
        <div className="section-inner">
          <div className="section-tag">Compliance</div>
          <h2 className="section-title display">Built to the Standard</h2>
          <div className="compliance-row reveal">
            <div className="compliance-item">
              <div className="usp-icon-wrap" style={{ marginBottom: "1rem" }}><ShieldIcon size={22} /></div>
              <h3>EPR Registered</h3>
              <p>Registered under India's Battery Waste Management Rules 2022 (notified by MoEFCC). EPR compliance certificates issued to every source producer — CPCB-ready, legally valid documentation per BWMR Rule requirements.</p>
            </div>
            <div className="compliance-item">
              <div className="usp-icon-wrap" style={{ marginBottom: "1rem" }}><TruckIcon size={22} /></div>
              <h3>Hazardous Waste Authorised</h3>
              <p>Authorised under Hazardous Waste Management Rules for handling, storage, and processing of battery waste. Consent to Establish and Consent to Operate obtained from State Pollution Control Board, Rajasthan.</p>
            </div>
            <div className="compliance-item">
              <div className="usp-icon-wrap" style={{ marginBottom: "1rem" }}><AtomIcon size={22} /></div>
              <h3>ESG Aligned</h3>
              <p>Operations aligned with global ESG reporting frameworks — helping producers meet Scope 3 GHG obligations. Our recycling closes the material loop on battery production, directly reducing the carbon footprint of new mining and virgin material extraction.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ background: "var(--panel)", borderTop: "var(--accent-line)" }}>
        <div className="section-inner" style={{ textAlign: "center" }}>
          <h2 className="section-title display">Ready to Recycle?</h2>
          <p className="section-body" style={{ margin: "0 auto 2rem" }}>
            Whether you have battery waste to dispose of or want to partner for EPR compliance, we're ready to talk.
          </p>
          <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap" }}>
            <a href="/#contact" className="btn-primary">Get in Touch</a>
            <Link to="/" className="btn-outline">← Back to Home</Link>
          </div>
        </div>
      </section>

    </main>
  );
}

export default WhatWeDoPage;